import { hasPermission } from './Permissions'

export const canAboutUsIntroView = () => hasPermission('about_us.view')
export const canAboutUsHistoryView = () => hasPermission('about_us.history.view')
export const canAboutUsMissionView = () => hasPermission('about_us.mission.view')

export function hasAnyAboutUsEditAccess() {
    return (
        hasPermission('about_us.intro.edit') ||
        hasPermission('about_us.history.edit') ||
        hasPermission('about_us.mission.edit')
    )
}

export function hasAnyAboutUsMenuAccess() {
    return canAboutUsIntroView() || canAboutUsHistoryView() || canAboutUsMissionView() || hasAnyAboutUsEditAccess()
}

export function aboutUsSectionUrl(slug) {
    return slug === 'quienes-somos' ? route('about-us.show') : route('about-us.show', slug)
}
